export default function (pageSeoData, language = "en") {
  if (!pageSeoData[language]) {
    throw "Seo object is not defined for the selected language.";
  }
  return pageSeoData[language];
}
